import { useEffect, useState } from "react";
import { pubSub } from "../ably";
import { CHANNELS } from "../channel/channels.js";

// How often the Viewers card re-reads the count (one Ably REST call).
export const VIEWER_COUNT_POLL_MS = 15000;

// Viewers = subscribers on the session's cme-common channel (every viewer page attaches to
// it - and so does this admin page). Ably counts connections, so two tabs are two viewers.
export async function readViewerCount() {
  const occupancy = await pubSub.getChannelOccupancy(CHANNELS.SESSION_DETAILS);
  return occupancy.subscribers;
}

// Live viewer count for the admin's Viewers card: read every VIEWER_COUNT_POLL_MS while the
// tab is visible, and at once when it becomes visible again or Ably (re)connects.
// null until the first read succeeds; a failed read keeps the last count.
export default function useViewerCount(sessionId) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    if (sessionId == null) return undefined;
    let cancelled = false;
    let timer = null;

    const read = async () => {
      clearTimeout(timer);
      if (document.visibilityState === "hidden") return; // picked up again on visibilitychange
      try {
        const n = await readViewerCount();
        if (!cancelled) setCount(n);
      } catch (err) {
        console.warn("[useViewerCount] reading the viewer count failed:", err?.message || err);
      }
      if (cancelled) return;
      clearTimeout(timer); // a read that overlapped this one may have scheduled already
      timer = setTimeout(read, VIEWER_COUNT_POLL_MS);
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") read();
    };
    const onConnectionChange = (connected) =>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      {
      if (connected) read();
    };

    read();
    document.addEventListener("visibilitychange", onVisibility);
    pubSub.onConnectionChange(onConnectionChange);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", onVisibility);
      pubSub.offConnectionChange(onConnectionChange);
    };
  }, [sessionId]);

  return count;
}
